import { render, staticRenderFns } from "./AgencyDashboardCard.vue?vue&type=template&id=3870d5a4&scoped=true&"
import script from "./AgencyDashboardCard.vue?vue&type=script&lang=js&"
export * from "./AgencyDashboardCard.vue?vue&type=script&lang=js&"
import style0 from "./AgencyDashboardCard.vue?vue&type=style&index=0&id=3870d5a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3870d5a4",
  null
  
)

export default component.exports